var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMapTool(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.97 4.5325C18.36 4.1425 18.36 3.5125 17.97 3.1225L15.14 0.2925C14.75 -0.0975 14.12 -0.0975 13.73 0.2925L9.24 4.7825L5.35 0.8925C4.57 0.1125 3.3 0.1125 2.52 0.8925L0.62 2.7925C-0.16 3.5725 -0.16 4.8425 0.62 5.6225L4.51 9.5125L0 14.0225V18.2625H4.24L8.76 13.7425L12.65 17.6325C13.6 18.5825 14.88 18.2325 15.48 17.6325L17.38 15.7325C18.16 14.9525 18.16 13.6825 17.38 12.9025L13.49 9.0125L17.97 4.5325ZM2.04 4.2025L3.93 2.3025L5.2 3.5725L4.02 4.7625L5.43 6.1725L6.62 4.9825L7.82 6.1825L5.92 8.0825L2.04 4.2025ZM13.27 11.6425L12.08 12.8325L13.49 14.2425L14.68 13.0525L15.95 14.3225L14.05 16.2225L10.16 12.3325L12.06 10.4325L13.27 11.6425ZM3.41 16.2625H2V14.8525L11.61 5.2425L12.91 6.5425L13.02 6.6525L3.41 16.2625ZM13.02 3.8225L14.43 2.4125L15.84 3.8225L14.43 5.2325L13.02 3.8225Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapTool);
export default __webpack_public_path__ + "static/media/map_tool.e3af0f4db4527dbf32e143b44e52b40c.svg";
export { ForwardRef as ReactComponent };